export enum StatsSpinnerSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export interface StatsSpinnerProps {
  color?: string;
  size?: StatsSpinnerSize;
}
